import React, { useEffect } from "react";
import { useCreateBlockNote } from "@blocknote/react";
import { BlockNoteView } from "@blocknote/mantine";
import "@blocknote/mantine/style.css";

function App() {
  const editor = useCreateBlockNote({});

  // Set up communication with Flutter
  useEffect(() => {
    if (editor) {
      // Listen for content changes and send to Flutter
      editor.onChange(() => {
        const content = editor.document;
        // Send to Flutter via the JS channel
        if (window.Flutter) {
          window.Flutter.postMessage(JSON.stringify(content));
        }
      });

      // Listen for messages from Flutter
      window.addEventListener("message", (event) => {
        if (event.data && typeof event.data === "string") {
          try {
            const message = JSON.parse(event.data);
            // Handle different commands from Flutter
            if (message.type === "setContent" && message.content) {
              editor.setContent(message.content);
            }
          } catch (e) {
            console.error("Error parsing message from Flutter:", e);
          }
        }
      });
    }
  }, [editor]);

  return (
    <div
      className="editor-container"
      style={{ height: "100vh", padding: "10px" }}
    >
      <BlockNoteView editor={editor} />
    </div>
  );
}

export default App;
